'use strict'

module.exports = {
	load: function (ua) {
		var s = document.createElement('script')
		s.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${ua}`)
		s.async = 'async'
		document.body.appendChild(s)

		window.dataLayer = window.dataLayer || []
		function gtag () {
			dataLayer.push(arguments)
		}
		gtag('js', new Date())
		gtag('config', ua)
	},
	pageview: function (arg) {
		try {
			if (arg.title) {
				window.gtag('config', process.env.UA, {
					'page_title': arg.name,
					'page_path': arg.path
				})
			}
		} catch (e) {
		}
	}
}



// WEBPACK FOOTER //
// ./src/core/analytics.js